<div class="question-panel question-panel--mini" id="question-panel-{{+max_item_id + 1}}" >
  @if (!showFlowController) {
    <div id="question-add-container">
      <a href="#question-panel-{{+max_item_id + 1}}" (click)="addItem()" data-scrollto="" class="question-panel__add" id="question-add-btn">
        <div class="button-control">
          <svg class="icon"><use xlink:href="#plus-filled"></use></svg><strong>Add Another</strong>
        </div>
      </a>
    </div>
  }
  @if (showFlowController) {
    <div id="question-container">
      <div class="form-group form-group--lg mb-15">
        <!-- question -->
        <label>{{activeQuestion?.question_copy}}</label>
        <app-question-controller
          [question]="activeQuestion"
          (questionAnswer)="activateNext($event)"
          [showLabel]="false">
        </app-question-controller>
      </div>
      <div class="question-panel__progress opacity-50">
        <div class="progress-line progress-line--sm">
          <div class="progress-line__track">
            <div class="progress-line__bar" id="mini-progress-bar" [ngStyle]="{width: progress}"></div>
          </div>
        </div>
      </div>
      <div class="question-panel__nav">
        <a href="javascript:void(0);" id="mini-prev" (click)="getPrevious()" class="question-panel__nav-prev button button--naked" [ngClass]="{ ' is-active': activeQuestion?.flow_index != 1 }">
          <svg class="icon icon--flip">
            <use xlink:href="#chevron-right"></use>
          </svg>
        </a>
        @if (+max_item_id !== 0) {
          <a href="javascript:void(0);" id="mini-remove" (click)="removeItem()" style="display: block" class="question-panel__nav-remove button button--naked">Remove</a>
        }
        <a href="javascript:void(0);" id="mini-next" (click)="submitResponse()"
          [attr.disabled]="disabledButton ? true : null" class="question-panel__nav-next button button--primary is-active">
          Next
        </a>
      </div>
    </div>
  }
</div>
